"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isThereARelevantOptionInNameScheme = void 0;
const isThereARelevantOptionInNameScheme = (artNameScheme, newOptions) => Object.keys(newOptions).some(key => artNameScheme.includes(key));
exports.isThereARelevantOptionInNameScheme = isThereARelevantOptionInNameScheme;